<script>
    import Panel from "./content-panel/Panel.svelte";
    import { onMount, onDestroy } from 'svelte';
    import { Pie } from 'svelte-chartjs';
    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        ArcElement,
        CategoryScale,
    } from 'chart.js';
    ChartJS.register(Title, Tooltip, /*Legend,*/ ArcElement, CategoryScale);
    import {guardHistory} from "../lib/guard-history";
    import { t, locale, locales } from "../../scripts/i18n";

    export let params = {};
    let divHeight;

    onMount(() => {
        window.scrollTo(0, 0);
    });

    let clearedFollowers = 41;
    let clearedComments = 17;
    let clearedPhotoTags = 15;
    let clearedDirectRequests = 23;

</script>

<div class="analyze-in-progress-wrap position-relative" style={`min-height: ${divHeight}px;`}>
    <div class="banner-top">

    </div>

    <div class="inner-content-wrap position-absolute top-0 w-100pc" bind:clientHeight={divHeight}>
        <Panel>
            <span slot="icon">
                <img src="/static/media/ant-design_history-outlined.5d8b662a.svg" alt="/" class="scan-block_top-img mr-5px">
            </span>
            <span slot="title">{$t('Protection report')}</span>
            <div slot="content">

                <div class="report_content">
                    <div class="diagram-block">
                        <main>
                            <div class="diagram-block_shadow">
                                <div class="pieID pie">
                                    <Pie width="340" height="340" options={{ maintainAspectRatio: true }} data={
                                {
                                      labels: ['Red', 'Purple', 'Forestgreen', 'Orange', 'Grey', ],
                                      datasets: [
                                        {
                                          data: [clearedFollowers, clearedComments, clearedPhotoTags, clearedDirectRequests, ],
                                          backgroundColor: [
                                            '#F7464A',
                                            '#46BFBD',
                                            '#FDB45C',
                                            '#949FB1',
                                            '#4D5360',
                                            '#AC64AD',
                                          ],
                                          hoverBackgroundColor: [
                                            '#FF5A5E',
                                            '#5AD3D1',
                                            '#FFC870',
                                            '#A8B3C5',
                                            '#616774',
                                            '#DA92DB',
                                          ],
                                        },
                                      ],
                                    }
                                } />
                                    <p class="pie-p"><span>{clearedFollowers + clearedComments + clearedPhotoTags + clearedDirectRequests}</span> <br>{$t('Total deleted')}</p>
                                </div>
                            </div>
                            <p class="diagram-block-tatle">{@html $t('Threats filtered over the last 30 days')}</p>
                            <ul class="pieID legend">
                                <li>
                                    <div class="dot-background" style="background: red;"></div>
                                    <em>{$t('Unwanted followers')}</em><span>{clearedFollowers}</span></li>
                                <li>
                                    <div class="dot-background" style="background: purple;"></div>
                                    <em>{$t('Unwanted comments')}</em><span>{clearedComments}</span></li>
                           `     <li>
                                    <div class="dot-background" style="background: forestgreen;"></div>
                                    <em class="em">{@html $t('Unwanted photo tags')}</em><span>{clearedPhotoTags}</span></li>
                                <li>
                                    <div class="dot-background" style="background: orange;"></div>
                                    <em>{@html $t('Unwanted direct requests')}</em><span>{clearedDirectRequests}</span></li>
                            </ul>
                        </main>
                    </div>
                    <div class="table-responsive">
                        <div class="table-headers">
                            <div class="w-33pc p-8px report_content-table-th_radius-l td-th-display-none">
                                {$t('Date and time of detection')}
                            </div>
                            <div class="w-33pc p-8px table-border-left">{$t('Username')}</div>
                            <div class="w-33pc p-8px table-border-left td-th-display-none">{$t('Reason for removal')}</div>
                        </div>
                        <div class="text-centered empty-table-diagram items-wrapper">
                            {#each guardHistory as item}
                                <div class="danger-info-wrap">
                                    <div class="w-33pc td-th-display-none">{item.createdAt}</div>
                                    <div class="w-33pc table-border-left"> @{item.username}</div>
                                    {#if item.type === 'bots'}
                                        <div class="w-33pc table-border-left td-th-display-none">Bot / Commercials account</div>
                                    {:else if item.type === 'comments'}
                                        <div class="w-33pc table-border-left td-th-display-none">Comments</div>
                                    {:else if item.type === 'photoTag'}
                                        <div class="w-33pc table-border-left td-th-display-none">Tag in photo</div>
                                    {:else if item.type === 'directRequest'}
                                        <div class="w-33pc table-border-left td-th-display-none">Direct request</div>
                                    {/if}
                                </div>
                            {/each}
                        </div>
                    </div>
                    <div class="bottom-btn-center"></div>
                </div>

            </div>
        </Panel>
    </div>
</div>

<style>
    .empty-table-diagram {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
    }

    .table-headers {
        display: flex;
        justify-content: space-evenly;
        align-items: center;

        text-align: center;
        font-family: Roboto;
        font-style: normal;
        font-size: 16px;
        color: #000;

        background-color: #dddddd;
    }

    .danger-info-wrap {
        display: flex;
        justify-content: space-evenly;
        align-items: center;

        text-align: center;
        font-family: Roboto;
        font-style: normal;
        font-size: 16px;
        color: #000;
    }
    .report_content{
        text-align: center;
        padding: 27px 15px;
    }
    .legend {
        list-style-type: none;
        margin: 0 0 0 0px;
        background: #fff;
        padding: 15px 0 15px 0px;
        font-size: 13px;
        text-align: left;
        width: 370px;
    }
    .legend li {
        height: 21px;
        margin-bottom: 30px;
        padding: 0;
    }

    @media (max-device-width: 767px) {
        .items-wrapper {
            padding: 10px;
        }
        .danger-info-wrap {
            justify-content: flex-start;
        }
        .table-border-left {
            border: none;
        }
        .legend {
            width: 250px;
        }
        .legend em {
            padding-right: 25px;
        }
        .diagram-block_shadow {
            padding: 30px 44px;
        }
    }
</style>